module.exports = __webpack_public_path__ + "img/figb.9cd9c514.png";